import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/user/list',
    name: 'UserList',
    component: () => import('@/views/apply/user/list'),
    meta: {
      title: i18n.t('router.user.user_list'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/grade',
    name: 'UserGrade',
    component: () => import('@/views/apply/user/grade'),
    meta: {
      title: i18n.t('router.user.user_level'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/settings',
    name: 'UserSettings',
    component: () => import('@/views/apply/user/settings'),
    meta: {
      title: i18n.t('router.user.user_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/grade/details',
    name: 'GradeDetails',
    component: () => import('@/views/apply/user/grade_details'),
    meta: {
      title: i18n.t('router.user.level_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/details',
    name: 'GradeEdit',
    component: () => import('@/views/apply/user/user_details'),
    meta: {
      title: i18n.t('router.user.user_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/tag',
    name: 'UserTag',
    component: () => import('@/views/apply/user/user_tag'),
    meta: {
      title: i18n.t('router.user.user_tag'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/user.js